import React, {Suspense} from "react"
import {Box} from "@mui/material"

import {HeaderWrapper, Title} from "../../../components"
import {StyledContainer} from "../../component"

import Autocomplete from "../../../../../../components/Autocomplete"
import AutocompleteProducts from "../../../../../../components/AutocompleteProducts"
import {SuggestionItem} from "../../../../../../models/autocomplete"
import AutoCompleteContainer from "../../../components/AutocompleteContainer"
import GridContent from "../../../components/GridContent"
import {
    ContentContainerStyled,
    SecondaryContentContainer,
    AutocompleteContent,
    GridWrapper,
    HeaderContainer,
} from "./components"

export type AutoCompleteProps = {
    isLoading: boolean
    isNoResults: boolean
    getAutoCompleteThunk: ({term, parameters, cookie}: {term: string; parameters: any; cookie: string}) => void
    numFound: number
    suggestions: SuggestionItem[] | null
    text: any
    parameters: any
    cookie?: string
    xxlBreakpointEnabled: boolean
    showSelectionHighlight: boolean
}

const Header = ({text}: any) => (
    <Box sx={{display: {xs: "block", md: "none"}}}>
        <HeaderContainer className="autocomplete-header" data-testid="autocomplete-header">
            <HeaderWrapper>
                <Title variant="h4">{text.headerText}</Title>
            </HeaderWrapper>
        </HeaderContainer>
    </Box>
)

export const Content = ({
    isLoading,
    getAutoCompleteThunk,
    text,
    isNoResults,
    parameters,
    cookie,
    xxlBreakpointEnabled,
    showSelectionHighlight,
}: AutoCompleteProps) => {
    const handleFocus = (term: string, suggestion: string) => {
        if (term === suggestion) return
        getAutoCompleteThunk({term: suggestion, parameters, cookie: cookie || ""})
    }

    return (
        <GridContent data-testid="autocomplete-grid-content">
            <StyledContainer xxlBreakpointEnabled={xxlBreakpointEnabled} data-testid="autocomplete-styled-container">
                <ContentContainerStyled
                    isNoResults
                    isRecentSearches={false}
                    xxlBreakpointEnabled={xxlBreakpointEnabled}
                    showSelectionHighlight={showSelectionHighlight}
                >
                    <GridWrapper isRecentSearches={false} showSelectionHighlight={showSelectionHighlight}>
                        <AutocompleteContent data-testid="autocomplete-content">
                            <Autocomplete handleFocus={handleFocus} />
                        </AutocompleteContent>
                    </GridWrapper>
                </ContentContainerStyled>
                <SecondaryContentContainer>
                    {isLoading && text.loadingText}
                    {!isLoading && (
                        <Suspense>
                            <AutocompleteProducts />
                        </Suspense>
                    )}
                </SecondaryContentContainer>
            </StyledContainer>
        </GridContent>
    )
}

export const EnrichAutoComplete = (props: AutoCompleteProps) => {
    const showContent = props.numFound > 0 && props.suggestions && props.suggestions.length > 0
    return (
        <AutoCompleteContainer>
            {showContent ? (
                <>
                    <Header text={props.text} />
                    <Content {...props} />
                </>
            ) : (
                props.isNoResults && <Header text={props.text} />
            )}
        </AutoCompleteContainer>
    )
}

export default EnrichAutoComplete
